<div class="overlay" (click)="toggleModal()"></div>
<div class="container flex-column m-0 p-0 d-flex">
    <div class="row g-0 m-0 p-4 justify-content-start borderb">
        <div class="col-md-11 ps-2 d-flex justify-content-start">
            <span class="popup-title">{{ "MONITORING_ACQUISITION" | translate }} {{"DETAILS" | translate}}</span>
        </div>
        <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
            <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg"></svg-icon>
        </div>
    </div>
    <div class="row g-0 m-0 body">
        <div class="row g-0 m-0 pt-3">
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-name">{{ "DEVICESETUP_METERNO" | translate }}</span>
            </div>
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-info">{{ acquisition.meterNumber ? acquisition.meterNumber : "/" }}</span>
            </div>
        </div>
        <div class="row g-0 m-0">
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-name">{{ "DEVICESETUP_METERIP" | translate }}</span>
            </div>
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-info">{{ acquisition.meterIP ? acquisition.meterIP : "/" }}</span>
            </div>
        </div>
        <div class="row g-0 m-0">
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-name">{{ "DEVICESETUP_METERPORT" | translate }}</span>
            </div>
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-info">{{ acquisition.meterPort ? acquisition.meterPort : "/" }}</span>
            </div>
        </div>
        <div class="row g-0 m-0">
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-name">{{ "SESSIONSTATUS" | translate }}</span>
            </div>
            <div class="col-md-6 d-flex justify-content-start align-items-start pt-3">
                <span class="item-info pt-1 pb-1"
                    [ngClass]="acquisition.sessionStatus ? 'status-completed' : 'status-failed'">{{
                    acquisition.sessionStatus ? "On" : "Off" }}</span>
            </div>
        </div>
        <div class="row g-0 m-0">
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-name">{{ "DEVICESETUP_METERTYPE" | translate }}</span>
            </div>
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-info">{{ acquisition.meterType ? acquisition.meterType : "/" }}</span>
            </div>
        </div>
        <div class="row g-0 m-0">
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-name">{{ "SESIONCREATEDON" | translate }}</span>
            </div>
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-info">{{
                    acquisition.lastReadTime ? (acquisition.lastReadTime | date: "dd MMM yyyy, h:mm a") : "/"
                }}</span>
            </div>
        </div>
        <div class="row g-0 m-0">
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-name">{{ "SESSION_ALIVE" | translate }}</span>
            </div>
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-info">{{
                    acquisition.sessionAlive ? (acquisition.sessionAlive | secondsToText) : "/"
                }}</span>
            </div>
        </div>
        <div class="row g-0 m-0">
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-name">{{ "SESSION_IDLE" | translate }}</span>
            </div>
            <div class="col-md-6 d-flex justify-content-start">
                <span class="item-info">{{
                    acquisition.sessionIndle ? (acquisition.sessionIndle | secondsToText) : "/"
                }}</span>
            </div>
        </div>
    </div>
    <div class="row g-0 m-0 p-3 align-items-end bordert">
        <div class="col-md-9 pt-2 pb-2 ps-2 d-flex justify-content-start" (click)="toggleModal()">
            <span role="button" class="item-name">{{ "CLOSE_WINDOW" | translate }}</span>
        </div>
    </div>
</div>
